import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import '../css/banner.scss';
// import axios from '@/services/axiosInstance';
import axiosInstance from "../helpers/Axios";



// // ✅ récupération automatique des images
// const images = import.meta.glob('../images/carousel/*.{jpg,jpeg,png,webp}', {
//   eager: true,
//   import: 'default',
// }) as Record<string, string>;

// // ✅ ordre stable (important)
// const carouselImages = Object.values(images).sort();

const Banner = () => {

  // const [images, setImages] = useState<string[]>([]);

  type CarouselImage = {
    file: string;
    src: string;
  };

  const [images, setImages] = useState<CarouselImage[]>([]);


  useEffect(() => {
    const loadCarousel = async () => {
      const res = await axiosInstance.get('/image');

      const carousel = res.data.find(
        (folder: any) => folder.name === 'carousel'
      );

      if (carousel?.files) {

        setImages(
          carousel.files.sort().map((file: string) => ({
            file,
            src: `${import.meta.env.VITE_BACKEND_URL}/images/carousel/${file}`
          }))
        );

      }
    };

    loadCarousel();
  }, []);

  if (images.length === 0) {
    return null; // ou un loader
  }

  return (
    <div>
      <div className="booking">
        <div>
          <Carousel
            infiniteLoop
            showThumbs={false}
            autoPlay
            emulateTouch
            swipeable
            useKeyboardArrows
            showStatus={false}
            interval={2000}
          // renderIndicator={renderIndicator}
          >


            {images.map((image) => (
              <div key={image.src} className="carousel-item">
                <div className="content">
                  <Link to="contact">
                    <div className="inner-content">
                      <img
                        src={image.src}
                        // alt={`Carousel ${index + 1}`}

                        alt={image.file
                          .replace(/\.[^/.]+$/, '')
                          .replace(/[-_]/g, ' ')
                        }

                        loading="lazy"
                      />
                    </div>
                  </Link>
                </div>
              </div>
            ))}

            {/* <div id="carousel-1" className="carousel-item">
            <div className="content">
              <Link to="contact">
                <div className="inner-content">
                  <img id="scheduling-17983227" src="/images/carousel/1-jonglerie.jpg" alt="Spectacle de jonglerie" />
                </div>
              </Link>
            </div>
          </div>
          <div id="carousel-2" className="carousel-item">
            <div className="content">
              <Link to="contact">
                <div className="inner-content">
                  <img id="scheduling-17983227" src="/images/carousel/2-mono.jpg" alt="Spectacle de monocycle" />
                </div>
              </Link>
            </div>
          </div>
          <div id="carousel-3" className="carousel-item">
            <div className="content">
              <Link to="contact">
                <div className="inner-content">
                  <img id="scheduling-17983227" src="/images/carousel/3-trapeze.jpg" alt="Spectacle de trapère" />
                </div>
              </Link>
            </div>
          </div>
          <div id="carousel-4" className="carousel-item">
            <div className="content">
              <Link to="contact">
                <div className="inner-content">
                  <img id="scheduling-17983227" src="/images/carousel/4-mono.jpg" alt="Spectacle de monocycle" />
                </div>
              </Link>
            </div>
          </div>
          <div id="carousel-5" className="carousel-item">
            <div className="content">
              <Link to="contact">
                <div className="inner-content">
                  <img id="scheduling-17983227" src="/images/carousel/5-equilibre.jpg" alt="Equilibre" />
                </div>
              </Link>
            </div>
          </div>
          <div id="carousel-6" className="carousel-item">
            <div className="content">
              <Link to="contact">
                <div className="inner-content">
                  <img id="scheduling-17983227" src="/images/carousel/6-jonglerie.jpg" alt="Jonglerie" />
                </div>
              </Link>
            </div>
          </div>
          <div id="carousel-7" className="carousel-item">
            <div className="content">
              <Link to="contact">
                <div className="inner-content">
                  <img id="scheduling-17983227" src="/images/carousel/7-diabolo.jpg" alt="Utilisation du diabolo" />
                </div>
              </Link>
            </div>
          </div>
          <div id="carousel-8" className="carousel-item">
            <div className="content">
              <Link to="contact">
                <div className="inner-content">
                  <img id="scheduling-17983227" src="/images/carousel/8-aerien.jpg" alt="Cours d'aérien" />
                </div>
              </Link>
            </div>
          </div>
          <div id="carousel-9" className="carousel-item">
            <div className="content">
              <Link to="contact">
                <div className="inner-content">
                  <img id="scheduling-17983227" src="/images/carousel/9-aerien.jpg" alt="Cours d'aérien" />
                </div>
              </Link>
            </div>
          </div>
          <div id="carousel-10" className="carousel-item">
            <div className="content">
              <Link to="contact">
                <div className="inner-content">
                  <img id="scheduling-17983227" src="/images/carousel/10-aerien.jpg" alt="Cours d'aérien" />
                </div>
              </Link>
            </div>
          </div>
          <div id="carousel-11" className="carousel-item">
            <div className="content">
              <Link to="contact">
                <div className="inner-content">
                  <img id="scheduling-17983227" src="/images/carousel/11-aerien.jpeg" alt="Spectacle d'aérien" />
                </div>
              </Link>
            </div>
          </div> */}
            {/* 
          {carouselImages.map((src, index) => (
            <div key={index} className="carousel-item">
              <div className="content">
                <Link to="contact">
                  <div className="inner-content">
                    <img
                      src={src}
                      alt={`Image du carousel ${index + 1}`}
                    />
                  </div>
                </Link>
              </div>
            </div>
          ))} */}

          </Carousel>
        </div>
      </div>

    </div>
  )
};

export default Banner;


//onclick="openScheduling(17983227)"

// interface Props {
//   lightId: string;
//   lightName: string;
//   lightComment: string;
// }

// const renderIndicator = (
//   clickHandler: (e: React.MouseEvent | React.KeyboardEvent) => void,
//   isSelected: boolean,
//   index: number,
//   label: string
// ) => React.ReactNode;
